import React from "react";
import { IconButton, Menu, MenuButton, MenuDivider, MenuItem, MenuList, } from "@chakra-ui/react";
import { useContext } from "react";
import { BiDuplicate } from "react-icons/bi";
import { StudioContext } from "../studioContext";
import { FiTrash } from "react-icons/fi";
import { duplicateItemCoordinates, widgetsWithAnimations } from "../helpers";
import { MdAnimation } from "react-icons/md";
import { useServices } from "../hooks/useServices";
export const LayoutItemMoreMenu = ({ layoutItem, ...menuButtonProps }) => {
    const { isLocked, setAnimationsModalOpened, widgets, layoutItems } = useContext(StudioContext);
    const { layoutService } = useServices();
    const widget = widgets.find((w) => w.name === (layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.widgetName));
    return widget ? (React.createElement(Menu, null,
        React.createElement(MenuButton, { as: IconButton, ...menuButtonProps }),
        React.createElement(MenuList, null,
            React.createElement(MenuItem, { icon: React.createElement(BiDuplicate, null), onClick: (e) => {
                    e.stopPropagation();
                    if (isLocked)
                        return;
                    const newItemId = Math.random().toString(36);
                    const newItemWidgetId = Math.random().toString(36);
                    layoutService.addLayoutItem({
                        ...layoutItem,
                        widget: {
                            ...layoutItem.widget,
                            id: newItemWidgetId,
                        },
                        id: newItemId,
                        ...duplicateItemCoordinates({
                            x: layoutItem.x,
                            y: layoutItem.y,
                        }),
                        z: layoutItems.length,
                    });
                } }, "Dupliquer"),
            widgetsWithAnimations.includes(widget.type.toLowerCase()) ? (React.createElement(MenuItem, { icon: React.createElement(MdAnimation, null), onClick: () => {
                    setAnimationsModalOpened(true);
                } }, "Animations")) : (React.createElement(React.Fragment, null)),
            React.createElement(MenuDivider, null),
            React.createElement(MenuItem, { icon: React.createElement(FiTrash, null), onClick: () => {
                    if (isLocked)
                        return;
                    layoutService.removeLayoutItem(layoutItem);
                } }, "Supprimer")))) : (React.createElement(React.Fragment, null));
};
